<div class="modal-header bg-warning text-dark">
    <h5 class="modal-title">⚠ Session Timeout Warning</h5>
</div>

<div class="modal-body text-center">
    <p>Your session will expire in</p>
    <h2 class="text-danger">{{ seconds }}</h2>
    <p>seconds</p>
</div>

<div class="modal-footer">
    <button class="btn btn-primary" (click)="continue()">Continue Session</button>
    <button class="btn btn-danger" (click)="logout()">Logout</button>
</div>